export default "__VITE_ASSET__C14LF4AU__"